import React, { forwardRef, useRef } from 'react';
import Draggable from 'react-draggable';

// Wrap a component in <Draggable>, including some of the necessary boilerplate.
export default function withDraggable(
  Component,
  { draggableProps: withDraggableProps, divProps: withDivProps } = {},
) {
  const Wrapped = ({
    draggableProps,
    divProps,
    forwardedRef,
    ...otherProps
  }) => {
    const nodeRef = useRef();
    return (
      <Draggable {...withDraggableProps} {...draggableProps} nodeRef={nodeRef}>
        <div {...withDivProps} {...divProps} ref={nodeRef}>
          <Component ref={forwardedRef} {...otherProps} />
        </div>
      </Draggable>
    );
  };

  const forward = (props, ref) => <Wrapped {...props} forwardedRef={ref} />;
  const name = Component.displayName || Component.name;
  forward.displayName = `withDraggable(${name})`;
  return forwardRef(forward);
}
